<template>
  <v-dialog v-model="showModal" width="400" @click:outside=closeDialog>
      <v-card max-width="400">
        <v-card-title class="d-flex justify-space-between align-center">
          <div class="text-h5 text-medium-emphasis ps-2 title-text" >add tag</div>
          <v-btn icon="mdi-close" variant="text" @click=closeDialog></v-btn>
        </v-card-title>
        <v-divider class="mb-4"></v-divider>
        <v-card-text>
          <v-sheet class="mx-auto" width="300">
            <v-form @submit.prevent ref="form">
              <v-text-field v-model="this.currentRow.ticker" id="ticker" label="ticker" variant="underlined" class="form_field" disabled></v-text-field>
              <v-select
                label="select tag"
                :items="this.tags.filter(tag => tag.broad_id === this.currentRow.broad.id)"
                item-title="path"
                item-value="id"
                v-model="this.selectedTag"
                :rules="[required]"
              ></v-select>
            </v-form>
          </v-sheet>
        </v-card-text>
        <template v-slot:actions>
          <v-btn v-on:click="submitForm" class="mt-2 submit_button" type="submit" block>Submit</v-btn>
        </template>
      </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';
import { mapState, mapMutations} from 'vuex';

export default {
  props: {
    show: Boolean,
    currentRow: Object
  },
  data() {
    return {
      tags: [],
      selectedTag: null,
    }
  },
  async created() {
    this.getTags();
  },
  computed: {
    ...mapState({
      token: "token"
    }),
    showModal: {
      get () {
        return this.show
      }
    },
  },
  methods: {
      ...mapMutations(["showSnackbar"]), 
    async submitForm(e) {
      e.preventDefault();
      const { valid } = await this.$refs.form.validate();
      if (!valid) return;
      try {
        
        await axios.request({
          url: "/securities/categorisations/" + this.currentRow.id + "/addtag",
          method: "PUT",
          headers: {
              Authorization: `Bearer ${this.token}`
          },
          data: {
            tag_id: this.selectedTag
          }
        });
          this.resetDataValues(); // clear form field values
          this.$parent.getCategories(); // update list on local view
          this.$emit("close"); // close modal via parent
      } catch (error) {
        this.showSnackbar({ message: 'Failed to update category tag' });
      }
    },
    async getTags(){
      try {
      const response  = await axios.get("/securities/categorisations/config/tags/",
      {
        headers: {
          Authorization: `Bearer ${this.token}`
        },
      });
        this.tags = response.data;

      
      } catch (error) {
        this.showSnackbar({ message: 'Failed to load tags' });
      }
    },
    resetDataValues(){
      this.selectedTag = "";
    },
    closeDialog(){
      this.resetDataValues();
      this.$emit('close');
    },
    required (v) {
        return (v !== null && v !== undefined && v !== '') || 'required'
    },
  } 
}
</script>

<style scoped>

.title-text, .body-text, .form_field, .submit_button {
  font-family: "Space Grotesk", "Courier New", Courier, monospace, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

</style>